.container {
  display: flex;
  flex-direction: column;
}

.dropzone {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
  padding: 16px;
}
